// Rome is the business clock, as in fleequid-logs and FLBI.
const TIME = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
// en-CA writes 2026-10-14: a day's key that sorts.
const DAY_KEY = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome' });
const DAY_LABEL = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
const SHORT_DAY = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', day: 'numeric', month: 'short' });
const STAMP = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Rome',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
});

export const romeTime = (iso: string): string => TIME.format(new Date(iso));
export const dayKey = (iso: string): string => DAY_KEY.format(new Date(iso));
export const stamp = (iso: string): string => STAMP.format(new Date(iso)).replace(',', ' ·');

// Today, Yesterday, then the date.
export function dayLabel(iso: string, now: number): string {
    const key = dayKey(iso);
    if (key === DAY_KEY.format(new Date(now))) {
        return 'Today';
    }
    if (key === DAY_KEY.format(new Date(now - 24 * 3600 * 1000))) {
        return 'Yesterday';
    }

    return DAY_LABEL.format(new Date(iso)).replace(',', '');
}

// How long ago, in words that fit a column: "just now", "5 minutes ago", "3 hours ago", "yesterday", "on 14 Oct".
export function ago(iso: string, now: number): string {
    const seconds = Math.max(0, Math.round((now - Date.parse(iso)) / 1000));
    if (seconds < 45) {
        return 'just now';
    }
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) {
        return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    const hours = Math.round(minutes / 60);
    if (hours < 24) {
        return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    }
    const days = Math.round(hours / 24);
    if (days === 1) {
        return 'yesterday';
    }
    if (days < 7) {
        return `${days} days ago`;
    }

    return `on ${SHORT_DAY.format(new Date(iso))}`;
}

export const plural = (count: number, one: string, many = `${one}s`): string => `${count.toLocaleString('en-US')} ${count === 1 ? one : many}`;

export function initials(name: string): string {
    const words = name
        .trim()
        .split(/[\s._-]+/)
        .filter(Boolean);
    const letters = words.length > 1 ? `${words[0]?.[0] ?? ''}${words[1]?.[0] ?? ''}` : name.slice(0, 2);

    return letters.toUpperCase() || '?';
}

// A value as one line in a row: its first line, and how many follow.
export function valuePreview(value: string): { line: string; more: number } {
    const lines = value.split('\n');

    return { line: lines[0] ?? '', more: lines.length - 1 };
}

export const MASK = '••••••••••••';
